/**
 * Component to show the listing information for all the tests passed
 */

import * as React from 'react';
import { Card, Breadcrumb, Row } from 'antd';
import { IcommonProps } from './common/props';
import strings from '../eyeguide-localization/reports/string.reports';
// import Token from './common/token';
import FilterRow from './reports/reports.filter';
import Table from './reports/reports.table';
import FailedReportsTable from './reports/failedreports.table';
import Service from '../service/apolloclient.service';
import '../css/Reports.scss';
import Utils from './common/utils';
import { BASELINETYPE, PROFILE_KEYS } from './common/constants';
import Print from './common/print';
import Export from './common/export';
import SessionStorage from '../service/sessionstorage';
/**
 * Property definition 
 */
interface IReportsProps extends IcommonProps {
    isFocusUser: boolean;
    loading: boolean;
    organizations: Array<any>;
}

/**
 * State definition
 */
interface IReportsState {
    loading: boolean;
    rosterids: Array<string>;
    tests: Array<any>;
    pagination: any;
    failedTestPagination: any;
    filter: any;
    sort: any;
    failedTestSort: any;
    testRange: string;
    isTestLoaded: boolean;
    failedtests: Array<any>;
    failedloading: boolean;
    isFailedTestLoaded: boolean;
    failedTestOptions: Array<any>;
}

export default class Reports extends React.Component<IReportsProps, IReportsState> {
    
    iframe: HTMLIFrameElement | null;
    
    constructor(props: IReportsProps) {
        super(props);
        var meta = SessionStorage.getReportMeta();
        this.state = {
            isTestLoaded: false,
            testRange: '',
            loading: false,
            rosterids: [],
            tests: [],
            pagination: meta ? meta.pagination : { pageSize: 100, current: 1, total: 0},
            failedTestPagination : meta && meta.failedTestPagination ? 
                                    meta.failedTestPagination : { pageSize: 100, current: 1, total: 0},
            filter: meta ? meta.filter : {rosterids: [], range: [], filter: {}},
            sort: meta ? meta.sort : {field: 'datetime', order: 'ascend'},
            failedTestSort: meta && meta.failedTestSort ? meta.failedTestSort : {field: 'datetime', order: 'ascend'},
            failedloading: false,
            isFailedTestLoaded: false,
            failedtests: [],
            failedTestOptions: meta && meta.failedTestOptions ? meta.failedTestOptions : []       
        };
    }

    componentDidMount() {
        console.log(navigator.language);
        strings.setLanguage(navigator.language);
        var meta = SessionStorage.getReportMeta();
        if (
            meta && meta.isTestLoaded &&
            meta.filter.rosterids && 
            meta.filter.rosterids.length > 0 && 
            meta.filter.range.length > 0 
        ) {
            this.loadData({
                rosterids: this.state.filter.rosterids, 
                range: this.state.filter.range, 
                pagination: this.state.pagination,
                filter: this.state.filter.filter,
                sort: this.state.sort
            });
            this.loadFailedTestData(
                {
                    rosterids: this.state.filter.rosterids, 
                    range: this.state.filter.range, 
                    pagination: this.state.failedTestPagination,
                    filter: this.state.filter.filter,
                    sort: this.state.failedTestSort,
                    failedTestOptions: this.state.failedTestOptions
                }
            );
        }
    }

    componentWillUnmount() {
        if ((this.state.isTestLoaded && this.state.tests.length > 0) || 
            (this.state.isFailedTestLoaded && this.state.failedtests.length > 0)) {
            SessionStorage.setReportMeta({
                rosterids: this.state.rosterids,
                filter: this.state.filter,
                pagination: this.state.pagination,
                failedTestPagination: this.state.failedTestPagination,
                sort: this.state.sort,
                failedTestSort: this.state.failedTestSort,
                testRange: this.state.testRange,
                isTestLoaded: this.state.isTestLoaded,
                failedTestOptions: this.state.failedTestOptions
            });
        } else {
            SessionStorage.clearReportMeta();
        }
    }

    render() {
        return (
            <div className="Reports">
                <iframe 
                    style={{height: 0, width: 0, border: 'none', position: 'absolute'}} 
                    ref={el => this.iframe = el} 
                />
                <Card>
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{strings.isReportsText}</Breadcrumb.Item>
                    </Breadcrumb>
                        <br/>
                    <h3>{strings.isManageTxt}</h3>
                </Card>
                <div className="reportBody" >
                    <FilterRow 
                        location="" 
                        organizations={this.props.organizations} 
                        handleLoadCall={this.handleLoadCall}
                        customState={this.state.filter.filter}
                        setParent={(e: object) => this.setState(e)}
                        isPrivacyEnabled={this.isPrivacyEnabled()}
                        isFailedTestFilterEnabled={this.isFailedTestReportEnabled()}
                    />
                    <Table 
                        tests={this.state.tests} 
                        pagination={this.state.pagination}
                        filter={this.state.filter}
                        sort={this.state.sort}
                        rosterids={this.state.rosterids}
                        onPaginationChange={this.handlePaginationChange}
                        loading={this.state.loading}
                        onPrint={() => this.printList()}
                        onExport={(key: string) => this.exportFile(key)}
                    />
                    {this.isFailedTestReportEnabled() ?
                    <> 
                        <Row>&nbsp;</Row>
                        <FailedReportsTable 
                            tests={this.state.failedtests} 
                            pagination={this.state.failedTestPagination}
                            filter={this.state.filter}
                            sort={this.state.failedTestSort}
                            rosterids={this.state.rosterids}
                            onPaginationChange={this.handleFailedPaginationChange}
                            loading={this.state.failedloading}
                            onPrint={() => this.printFailedList()}
                            onExport={(key: string) => this.exportFailedFile(key)}
                        />
                    </> : null
                    }
                </div>
            </div>
        );
    }

    handleLoadCall = async ({rosterids, range, filter, testRange, failedTestOptions}, callback: any) => {
        this.setState(
            { filter: {rosterids, range, filter}, testRange, loading: true, failedloading: true, failedTestOptions }, 
            () => {
                this.loadData({
                    rosterids, 
                    range, 
                    pagination: {...this.state.pagination, current: 1, total: 0},
                    filter,
                    sort: this.state.sort
                });
                if (this.isFailedTestReportEnabled()) {
                    this.loadFailedTestData({
                        rosterids, 
                        range, 
                        pagination: {...this.state.pagination, current: 1, total: 0},
                        filter,
                        sort: this.state.failedTestSort,
                        failedTestOptions
                    });
                }                
                callback();
            }
        );
    }

    handlePaginationChange = async ({pageSize, current}, {field, order}) => {
        this.setState(
            { 
                pagination: {...this.state.pagination, pageSize, current}, 
                sort: {field, order},
                loading: true 
            }, 
            () => this.loadData({
                ...this.state.filter,
                pagination: {pageSize, current},
                sort: {field, order}
            })
        );
    }

    handleFailedPaginationChange = async ({pageSize, current}, {field, order}) => {
        this.setState(
            { 
                failedTestPagination: {...this.state.failedTestPagination, pageSize, current}, 
                failedTestSort: {field, order},
                failedloading: true 
            }, 
            () => this.loadFailedTestData({
                ...this.state.filter,
                pagination: {pageSize, current},
                sort: {field, order},
                failedTestOptions: this.state.failedTestOptions
            })
        );
    }

    loadData = async ({rosterids, range, pagination, filter, sort}) => {        
        var ser = new Service();
        var data = await ser.getTestList({
            rosterids, range, pagination, filter, sort,
            primaryorgid: this.props.organizations.length > 0 ? this.props.organizations[0].primaryorganizationid : ''
        });
        return data ? 
            this.setState({
                tests: data.tests,
                loading: false,
                pagination: {...pagination, total: data.total},
                isTestLoaded: true
            }) : null;
    }

    loadFailedTestData = async ({rosterids, range, pagination, filter, sort, failedTestOptions}) => {
        var ser = new Service();
        var data = await ser.getFailedTestList({
            rosterids, range, pagination, filter, sort, failedTestOptions,
            primaryorgid: this.props.organizations.length > 0 ? this.props.organizations[0].primaryorganizationid : ''
        });
        return data ? 
            this.setState({
                failedtests: data.tests,
                failedloading: false,
                failedTestPagination: {...pagination, total: data.total},
                isFailedTestLoaded: true
            }) : null;
    }

    /**
     * Handles test list print
     */
    async printList() {
        let buildData: any;
        this.setState(
            {loading: true},
            async () => {
                var tests = await this.loadAllData();
                
                buildData = this.buildTestData(tests);
                if (buildData.length > 0) {
                    Print.printContents(buildData, strings.isReportsText, this.iframe);
                }
            }
        );
    }

    /**
     * Handles failed test list print
     */
     async printFailedList() {
        let buildData: any;
        this.setState(
            {loading: true},
            async () => {                
                var tests: any = await this.loadAllFailedTestData();
                buildData = this.buildTestData(tests, true, false);
                if (buildData.length > 0) {
                    Print.printContents(buildData, strings.isAdditionalInformationText, this.iframe);
                }
            }
        );
    }

    /**
     * Handles test list export
     */
    exportFile(key: string) {
        let buildData: any;
        this.setState(
            {loading: true},
            async () => {
                var tests = await this.loadAllData();
                let addProfileInfo = key === '1' ? false : true;
                buildData = this.buildTestData(tests, false, addProfileInfo);
                if (buildData.length > 0) {
                    Export.exportCSVFile(buildData, 'tests');
                }
            }
        );
    }

    /**
     * Handles failed test list export
     */
      exportFailedFile(key: string) {
        let buildData: any;
        this.setState(
            {loading: true},
            async () => {                
                var tests: any = await this.loadAllFailedTestData();
                let addProfileInfo = key === '1' ? false : true;
                buildData = this.buildTestData(tests, true, addProfileInfo);
                if (buildData.length > 0) {
                    Export.exportCSVFile(buildData, 'tests');
                }
            }
        );
    }

    private loadAllData = async () => {
        var ser = new Service();
        var filter = this.state.filter;
        var data = await ser.getTestList({
            rosterids: filter.rosterids, 
            range: filter.range, 
            pagination: {pageSize: -1, current: -1, total: 0}, 
            filter: filter.filter,
            sort: this.state.sort,
            primaryorgid: this.props.organizations.length > 0 ? this.props.organizations[0].primaryorganizationid : ''
        });
        this.setState({loading: false, isTestLoaded: true});
        return data ? data.tests : [];
    }

    private loadAllFailedTestData = async () => {
        var ser = new Service();
        var filter = this.state.filter;
        var data = await ser.getFailedTestList({
            rosterids: filter.rosterids, 
            range: filter.range, 
            pagination: {pageSize: -1, current: -1, total: 0}, 
            filter: filter.filter,
            sort: this.state.failedTestSort,
            primaryorgid: this.props.organizations.length > 0 ? this.props.organizations[0].primaryorganizationid : '',
            failedTestOptions: this.state.failedTestOptions
        });
        this.setState({failedloading: false, isFailedTestLoaded: true, loading: false, isTestLoaded: true});
        return data ? data.tests : [];
    }

    /**
     * Build test data from test list for Export/Print
     * @param tests Test List
     */
    private buildTestData(tests: Array<any>, isFaledTest: boolean = false, addProfileInfo: boolean = false) {
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            let data: any = {};
            data = {
                profile_name: element.athlete.firstname + ' ' + element.athlete.lastname          
            };

            if (addProfileInfo) {
                PROFILE_KEYS.forEach((key: string) => {
                    let profileInfo = element.athlete.playerinfo;
                    let dataKey = key === 'profileID' ? 'profile_id' : 'profile_' + key;   
                    data[dataKey] = Utils.getProfileValue(profileInfo, key);
                });
            }   

            data = {
                ...data,
                date: Utils.getDate(element.testtimestamp) + ' ' + Utils.getTime(element.testtimestamp),
                test_type: element.testtag + (element.bestbaseline === true && element.baseline === 1 ? ' (best)' : ''),
                score_type: isFaledTest ? 'Failed' : 
                                element.baseline === 1 ? BASELINETYPE.BASELINE 
                                    : Utils.getLocalizedTestType(element.range),
                score: Utils.formatNumber(element.score, 2),
                organization: element.organization.name,   
                organization_location:  this.renderCityState(element.organization),
                organization_email: element.organization.contactemail
            };

            if (isFaledTest) {
                data.username = element.user.username;
            }     

            columnData.push(data);
        });         
        return columnData;
    }

    private renderCityState = ({city, state}) => [city, state].filter(e => e).join(', ');

    private isPrivacyEnabled = () => {
        var orgs = this.props.organizations;
        for (var i = 0; i < orgs.length; i++) {
            if (orgs[i].isprimary && orgs[i].enableprivacy) {
                return true;
            }
        }
        return false;
    }

    private isFailedTestReportEnabled = () => {
        var orgs = this.props.organizations;
        for (var i = 0; i < orgs.length; i++) {
            if (orgs[i].isprimary && orgs[i].enablefailedtestreport) {
                return true;
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/components/reports.tsx